import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Typography } from 'seagull';
import { routes } from '~/constants';
const VendorNameLink = (param)=>{
    let { testId, vendorName, relationshipID } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        as: Link,
        to: routes.agreementMinisiteRoutes(relationshipID).agreement,
        testId: testId,
        variant: "paragraph1",
        noWrap: true,
        ellipsis: true,
        children: vendorName
    });
};
export default VendorNameLink;
